module.exports = __webpack_public_path__ + "static/media/close.99f58b18.svg";